module.exports = __webpack_public_path__ + "img/section4-2-mobile.03ddd583.png";